export enum StatusType {
  Canceled = 4,
  Scheduled = 3,
  Published = 2,
  InProgress = 1,
  Archived = 0
}
